import React from 'react'
import { Container, Row,Col } from 'react-bootstrap'
import { useState } from 'react';
import moment from 'moment';
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';

export default function FiberTeam_Complaint({complaintDetails, setComplaintDetails, isSubmitting, stock, setStock}) {

  const [unitFiberTeam, setUnitFiberTeam] = useState(0);
const locate = useLocation();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

// const [sumbitHide,setSubmitHide]=useEffect(true)
    

useEffect(() => {
  console.log("Updated materialsSelected:", complaintDetails?.workAssign?.fiberTeam?.materialsSelected);
}, [complaintDetails]);


        const staffName = useSelector((state) => state.staffname);
    console.log(complaintDetails)
    
      const [materialInput, setMaterialInput] = useState({
        material: "",
        materialType: "",
        unit: "",
      });
  const incrementUnitFiberTeam = () => {
    setUnitFiberTeam(prevUnit => prevUnit + 1);
  };

  const [materialFetch, setMaterialFetch] = useState([]);

    const handleMaterialInputChange = (e) => {
      const { name, value } = e.target;
  
      const numericFields = ["unit", "sellingCost"];
  
      setMaterialInput((prev) => ({
        ...prev,
        [name]: numericFields.includes(name) ? Number(value) : value,
      }));
    };
  
  
    const handleRemoveMaterial = (index) => {
      const updated = [...stock.materials];
      updated.splice(index, 1);
      setStock((prev) => ({
        ...prev,
        materials: updated,
      }));
    };
  
    const filteredMaterialTypes = materialInput.material
      ? materialFetch.filter((d) => d.material === materialInput.material)
      : [];
  
  const addMaterialToStock = () => {
    console.log("addMaterialToStock");
  
    const { material, materialType, unit, sellingCost } = materialInput;
  
    if (!material || !materialType || !unit) {
      toast.error("Please fill in all material fields before adding.");
      return;
    }
  
    const isDuplicate = stock.materials.some(
      (item) => item.materialRequire === material && item.materialType === materialType
    );
  
    if (isDuplicate) {
      toast.warning("This material with the same type is already added.");
      return;
    }
  
    const newMaterial = {
      materialRequire: material,
      materialType: materialType,
      unit,
     
     
    };
  
    // Update `stock.materials`
    setStock((prev) => ({
      ...prev,
      materials: [...prev.materials, newMaterial],
    }));
  
    // Clear input fields
    setMaterialInput({
      material: "",
      materialType: "",
      unit: "",
      sellingCost: "",
    });
  
    console.log("New Material Added to FiberTeam and Materials");
  };

    useEffect(() => {
    const fetchStockDropdownMaterials = async () => {
      try {
        const response = await axios.get(`${apiUrl}/manage-stock/get-all`);
        setMaterialFetch(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchStockDropdownMaterials();
  }, [apiUrl]);
  
      const createdDate = complaintDetails?.createdDate; // ISO string from backend
  const daysAgo = moment().diff(moment(createdDate), 'days');
    
  const formatDatecreate = (isoDate) => {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };


const handleSubmit = async (e) => {
  e.preventDefault();

  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = now.getFullYear();
  const updatedDate = `${day}-${month}-${year}`;
  let hours = now.getHours();
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  const updatedTime = `${hours}:${minutes} ${ampm}`;

  let updatedComplaintDetails = { ...complaintDetails };
  delete updatedComplaintDetails._id; // Remove _id to prevent backend errors

  const prevFiberTeam = complaintDetails?.workAssign?.fiberTeam || {};
  const prevMaterials = prevFiberTeam.materials || [];
  const newMaterials = stock.materials || [];

  // Auto-include pending input if user didn't click '+'
  const currentInputMaterial = (materialInput.material && materialInput.materialType && materialInput.unit) 
    ? [{ materialRequire: materialInput.material, materialType: materialInput.materialType, unit: materialInput.unit }]
    : [];

  const finalMaterials = [...prevMaterials, ...newMaterials, ...currentInputMaterial];

  if (finalMaterials.length === 0) {
    return Swal.fire({
      icon: "warning",
      title: "Please select at least one material",
    });
  }

  const result = await Swal.fire({
    title: "Update the changes?",
    showCancelButton: true,
    confirmButtonText: "Update",
  });

  if (!result.isConfirmed) return;

  try {
    updatedComplaintDetails.workAssign = {
      ...complaintDetails.workAssign,
      fiberTeam: {
        ...prevFiberTeam,
        ...stock,
        materials: finalMaterials,
        materialsSelected: true, // ✅ Set true to hide the button
      },
    };

    await axios.post(apiUrl + "update-lead-complaint", updatedComplaintDetails, {
      headers: { "Content-Type": "application/json" },
    });

    setComplaintDetails(updatedComplaintDetails);
    setStock((prev) => ({
      ...prev,
      materials: [],
    }));

    Swal.fire("Success!", "Data updated successfully", "success");
    } catch (error) {
      console.error("Fiber Team Submission Error:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      const errorMsg = error.response?.data?.message || error.response?.data?.error || error.message || "Something went wrong!";
      Swal.fire("Error", `Fiber Team: ${errorMsg}`, "error");
    }
};


  
  return (
    <div>
        <Container className='fiberteam-container'>
            

              <Row>
                <Col md={9} sm={3}>
                         <div className='plan-details-container-border-complaint mt-5 text-center ms-5'>
  <p  style={{ fontSize:"13px"}}className='mt-3'>
    {/* <span className='text-primary'>Network</span> */}
     Complaint - <span className='text-primary'>{complaintDetails?.complaintType}</span> Customer Affected - <span className='text-primary'>{complaintDetails?.complaintcustomerAffected} @ </span>Location - <span className='text-primary'>{complaintDetails?.complaintlocation}</span></p>                         
   <p style={{ fontSize:"13px"}}  class="mb-3"> Complaint Open Date - <span className='text-primary'>{formatDatecreate(complaintDetails?.createdDate)} , </span> Complaint Open Last - <span className='text-primary'>{daysAgo} Days</span></p>                         
   </div>
                </Col>
                  <Col md={3} sm={3}>
                  {complaintDetails?.workAssign?.fiberTeam?.materialsSelected !==true &&(
                                 <Col md={3} sm={3}>
                  
                               <button  onClick={(e) => handleSubmit(e)} className='blue-btn'>Submit</button>
                              </Col>
                              )}
                </Col>
              </Row>
    
   
   {Array.isArray(complaintDetails?.workAssign?.fiberTeam?.materials) &&
    complaintDetails?.workAssign?.fiberTeam?.materials?.length > 0 && (
      <div className='mt-5'>
        <h6>Added Material</h6>
     <div className='fiber-team-fiber-container mt-3 mb-4'>
       <Row className='mt-2'>
         {complaintDetails.workAssign.fiberTeam.materials.map((team, teamIndex) => (
           <Col key={`${teamIndex}`} xs={12} sm={6} md={4} className="mb-2">
             <div className="d-flex align-items-center justify-content-between p-2 rounded shadow-sm">
               <span>
                 {team.materialRequire} (<span>{team.materialType}</span>) -{" "}
                 <span className='text-primary'>{team.unit}</span>
               </span>
             </div>
           </Col>
         ))}
       </Row>
     </div>
     </div>
   )}
   
   
   
   
   
 {(
   !(complaintDetails?.workAssign?.fiberTeam?.materials?.length > 0) ||
   complaintDetails?.workAssign?.fiberTeam?.approvedStatus ==="Resubmit"
 ) && (   
              <Row>
                        {stock.materials.length > 0 && (
                 <>
                   <h6 className="add-material">Added Materials</h6>
                   <Col xs={12} className="mt-1 mb-2 border-container-plus1">
                     {stock.materials.map((mat, index) => (
                       <div
                         key={index}
                         className="d-flex justify-content-between align-items-center bg-white border rounded p-2 mb-2"
                       >
                         <div className="fw-bold">
                           <span>
                             {mat.materialRequire} ({mat.materialType}) •{" "}
                           </span>
                           <span className="text-primary">
                             {["2F", "4F", "6F", "Cat 6 Cable"].includes(mat.materialType)
                               ? `${mat.unit} M`
                               : mat.unit}
                           </span>
                         </div>
               
                         <button
                           type="button"
                           className="btn btn-sm btn-outline-secondary"
                           onClick={() => handleRemoveMaterial(index)}
                         >
                           <span style={{ fontSize: "20px" }}> ×</span>
                         </button>
                       </div>
                     ))}
                   </Col>
                 </>
               )}
               
    
                <Col xs={12} md={6} className="text-start">
                  <Row className="mt-3">
                    <Col xs={12} md={6} className="text-start">
                      <label className="">Materials</label>
                      <br />
                      <select
                        className="dropbtn form-input-select"
                        name="material"
                        value={materialInput.material}
                        onChange={handleMaterialInputChange}
                      >
                        <option value="">Select Material</option>
                        {[...new Set(materialFetch.map((d) => d.material))].map(
                          (material, i) => (
                            <option key={i} value={material}>
                              {material}
                            </option>
                          )
                        )}
                      </select>
                    </Col>
                    <Col xs={12} md={6} className="text-start">
                      {stock.materials && ( // Show only if materials is selected
                        <>
                          <label className="">Material Types</label>
                          <br />
                          <select
                            className="dropbtn form-input-select"
                            name="materialType"
                            value={materialInput.materialType}
                            onChange={handleMaterialInputChange}
                          >
                            <option value="">Select Material Type</option>
                            {filteredMaterialTypes.map((d, i) => (
                              <option key={i} value={d.materialType}>
                                {d.materialType}
                              </option>
                            ))}
                          </select>
                        </>
                      )}
                    </Col>
                  </Row>
                </Col>
    
                <Col xs={12} md={6} className="text-start">
                  <Row className="mt-3">
                    <Col xs={12} md={6} className="text-start">
                      <label className="">Unit</label>
                      <br />
                      <input
                        className="form-input"
                        type="number"
                        onKeyDown={(e) => {
                          if (
                            ["e", "E", "+", "-"].includes(e.key) ||
                            (e.key &&
                              !/[0-9]/.test(e.key) &&
                              e.key !== "Backspace" &&
                              e.key !== "ArrowLeft" &&
                              e.key !== "ArrowRight")
                          ) {
                            e.preventDefault();
                          }
                        }}
                        name="unit"
                        value={materialInput.unit}
                        onChange={handleMaterialInputChange}
                      />
                    </Col>
    
    
    
                    <Col xs={12} md={2} className="text-start mt-3">
    
                      <br />
                      <button
                        type="button"
                        onClick={() => addMaterialToStock()}
                        className="blue-btn plus-blue-btn"
                        style={{ fontSize: "20px" }}
                      >
                        +
                      </button>
                    </Col>
                  </Row>
    
                </Col>
    
              </Row>
    
    
                      )}
        </Container>

    </div>
  )
}
